if (!("requestSubmit" in HTMLFormElement.prototype)) {
  HTMLFormElement.prototype.requestSubmit = function (submitter) {
    if (submitter) {
      submitter.click()
      return
    }

    const button = document.createElement("input")
    button.type = "submit"
    button.hidden = true
    this.appendChild(button)
    button.click()
    this.removeChild(button)
  }
}
